import { runtime } from '../../runtime/Runtime';
export class AppUrl {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get pathname() {
        if (runtime.isBrowserRuntime) {
            return runtime.solidBrowserRuntime.browserAddressBar.locationSnapshot.pathname;
        }
    }
    get query() {
        if (runtime.isBrowserRuntime) {
            return runtime.solidBrowserRuntime.browserAddressBar.query;
        }
    }
}
